import { render, staticRenderFns } from "./EspondiloartritesPerifericoSummary.vue?vue&type=template&id=85197e30&scoped=true&"
import script from "./EspondiloartritesPerifericoSummary.vue?vue&type=script&lang=js&"
export * from "./EspondiloartritesPerifericoSummary.vue?vue&type=script&lang=js&"
import style0 from "./EspondiloartritesPerifericoSummary.vue?vue&type=style&index=0&id=85197e30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85197e30",
  null
  
)

export default component.exports